import { render, staticRenderFns } from "./ImgWithLoading.vue?vue&type=template&id=c22901ca&scoped=true&"
import script from "./ImgWithLoading.vue?vue&type=script&lang=js&"
export * from "./ImgWithLoading.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c22901ca",
  null
  
)

export default component.exports